import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const EMOJIS = ["❤️", "😂", "😮", "😢", "😍", "🔥", "👏"];

export function StoryReplyBar({ story, onFocus, onBlur, onReacted }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const react = async (emoji) => {
    try { await api.post(`/stories/${story.id}/react`, { emoji }); onReacted(story.id, emoji); toast.success(`${emoji} gesendet`); } catch (e) { toast.error(formatErr(e)); }
  };
  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try { await api.post(`/stories/${story.id}/reply`, { text }); setText(""); toast.success("Antwort gesendet – siehe Nachrichten"); e.target.querySelector("input")?.blur(); }
    catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };
  return (
    <div className="absolute bottom-0 inset-x-0 z-20 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] space-y-2 bg-gradient-to-t from-black/60 to-transparent" data-testid="story-reply-bar">
      <div className="flex justify-between gap-1">
        {EMOJIS.map((e) => (
          <button key={e} onClick={() => react(e)} data-testid={`story-react-${EMOJIS.indexOf(e)}`}
            className={`w-10 h-10 rounded-full text-2xl flex items-center justify-center transition-transform active:scale-125 hover:scale-110 ${story.my_reaction === e ? "bg-white/30" : ""}`}>{e}</button>
        ))}
      </div>
      <form onSubmit={send} className="flex items-center gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} onFocus={onFocus} onBlur={onBlur} maxLength={500} placeholder="Privat antworten …" data-testid="story-reply-input"
          className="flex-1 min-w-0 h-11 px-4 rounded-full bg-white/15 border border-white/40 text-white placeholder:text-white/70 text-base sm:text-sm focus:outline-none focus:bg-white/25" />
        <button disabled={busy || !text.trim()} data-testid="story-reply-send" aria-label="Senden" className="w-11 h-11 rounded-full pink-gradient text-white flex items-center justify-center disabled:opacity-50"><Send className="w-4 h-4" /></button>
      </form>
    </div>
  );
}
